import {ChangeDetectorRef, Component, EventEmitter, OnInit, Output} from '@angular/core';
import {WorkflowModel, WorkflowState, WorkflowStateDataInfo} from "../../../../workflow/models/workflow.model";
import {InvalidateSubject} from "@shared/helpers/invalidate.subject";
import {IWorkflowStepComponent} from "@shared/interfaces/workflow-step.interface";
import {Dac6ReporterApiService} from "../../../services/dac6-reporter.service";
import {getAllCurrencies, ParticleState} from "@shared/store/reducers/particle.reduer";
import {select, Store} from "@ngrx/store";
import {DialogService} from "@shared/services/dialog-service";

@Component({
    standalone: false,
    selector: 'particle-workflow-transaction-selector',
  templateUrl: './workflow-transaction-selector.component.html',
  styleUrls: ['./workflow-transaction-selector.component.scss']
})
export class WorkflowTransactionSelectorComponent implements OnInit, IWorkflowStepComponent {
  currentStep: WorkflowState;
  filterId: string;
  filterTemplateId: string;
  invalidateSubject: InvalidateSubject;
  apiKey: string = null;
  selectionKey: string = null;
  leftSourceType: string = null;
  rightSourceType: string = null;
  inputs = null;
  argumentsKey = ['FROM_DATE', 'TO_DATE', 'TAX_YEAR_END' ];
  itemUrlIndex = 0;
  isAppliedToggle: boolean;
  arrangements: any[];
  selectedArrangement: any;
  currencies: any[];
  selectedCurrency: any;
  consolidatedTransactions = {};
  @Output() GridCellValueChanged = new EventEmitter();

  onLoad(workflow: WorkflowModel, currentStep: WorkflowState) {

    this.currentStep = currentStep;
    this.argumentsKey.forEach(key=>{
      if(this.currentStep.Arguments[key]){
        if(this.inputs === null) this.inputs = {};
        this.inputs[key] =  this.currentStep.Arguments[key];
      }
    });
    this.apiKey = this.currentStep.Arguments['EntitySelectorApiKey']?this.currentStep.Arguments['EntitySelectorApiKey']: null;
    this.leftSourceType = this.currentStep.Arguments['LeftSourceType']?this.currentStep.Arguments['LeftSourceType']: null;
    this.rightSourceType = this.currentStep.Arguments['RightSourceType']?this.currentStep.Arguments['RightSourceType']: null;
    this.selectionKey = this.currentStep.Arguments['SelectionKey']?this.currentStep.Arguments['SelectionKey']: null;
    this.itemUrlIndex = this.currentStep.Arguments['ItemUrlIndex']?this.currentStep.Arguments['ItemUrlIndex']: 0;
    this.isAppliedToggle = this.currentStep.Arguments['isAppliedToggle']?this.currentStep.Arguments['isAppliedToggle']:false;
    const filterIdInput = this.currentStep.Inputs.find(o=>o.Name==='FilterId');
    const filterTemplateInput = this.currentStep.Inputs.find(o=>o.Name==='FilterTemplateId');
    if(filterIdInput) {
      this.filterId = filterIdInput.Value;
      this.filterTemplateId = filterTemplateInput.Value;
      this.invalidateSubject.invalidate();
    }
    this.fetchComponentData();
  }
  canMoveNext(): boolean {
    if(Object.keys(this.consolidatedTransactions).length > 0){
      if(this.selectedArrangement && this.selectedCurrency)return true;
      this.dialogService.showDialogMessage('Warning', 'Please assign a case and select a currency to consolidate transactions.');
      return false;
    }
    return true;
  }
  canMoveNext$(): import("rxjs").Observable<boolean> {
  return null;
}
  canCancel(): boolean {
    return true;
  }

  constructor(public changeDetectorRef: ChangeDetectorRef,
              public particleStore: Store<ParticleState>,
              public dialogService: DialogService,
              public dac6ReporterApiService: Dac6ReporterApiService) {
    this.invalidateSubject = new InvalidateSubject();
  }

  ngOnInit() {
  }
  onSelectCurrency(event){
    this.selectedCurrency = event.value;
    this.GridCellValueChanged.emit({
      id: 'Currency',
      value: this.selectedCurrency
    });
    console.log(event);
  }
  onSelectCase(event){
    this.selectedArrangement = event.value;
    this.GridCellValueChanged.emit({
      id: 'Case',
      value: this.selectedArrangement
    });
    console.log(event);
  }
  private fetchComponentData() {

    this.dac6ReporterApiService.getAvailableTransactionalArrangements().subscribe(cases=>{
      this.arrangements = cases;
    });
    this.particleStore.pipe(select(getAllCurrencies)).subscribe(currencies => {
      this.currencies  = currencies;
    });
  }
  onGridCellValueChanged(event){
    if (event.action) {
      switch (event.action.id) {
        case 'Edit':
          this.edit(event);
          break;
      }
    }
  }

  private edit(event: any) {
    this.dialogService.showCellEditorDialog(event.item, event.fieldDefinition, '800px', '800x', this.leftSourceType).subscribe(state => {
      console.log('After Edit', state);
      if (state.action === 'OK') {
        console.log('');
        const value = event.item.cells[event.fieldDefinition.key];
        if(event.fieldDefinition.key === 'IsConsolidated' && value){
          event.item.cells[event.fieldDefinition.key].displayText = value.value;
          if(value.value === "Yes"){
            this.consolidatedTransactions[ event.item.id ] = true;
          }
          else{
            delete this.consolidatedTransactions[event.item.id];
          }
          this.GridCellValueChanged.emit({
            id: 'ConsolidatedTransactions',
            value: Object.keys(this.consolidatedTransactions)
          })
        }
      }
    });
  }
}
